import angular from 'angular'

import component from './product-tile.component'

let module = angular.module('productTile', [])

.component('productTile', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-tile/index.js